<template>
  <div>
    <nav-breadcrumb :menu="[{label: ' 选择匹配'}]"/>
    <div class="xzpadd10 bg-purple of">
      <data-table
        :table-data="tableData"
        :columns="columns"
        :page.sync="page"
        :pageSize.sync="pageSize"
        :filters.sync="filters"
        :actions="actions"
      />
    </div>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import {xmlBuildQuery} from "../../filters/CommonActions";
    export default {
        name: "OutstandingList",
      data(){
        return{
          detailId:this.$route.query['detailId']||'',
          columns:[
            {
              type: 'index'
            },
            {
              label: '贷款编号',
              field: 'fi__transactionNo'
            },
            {
              label: '客户姓名',
              field: 'c__customerName'
            },
            {
              label: '贷款开始时间',
              field: 'fi__startDate'
            },
            {
              label: '贷款结束时间',
              field: 'fi__endDate'
            },
            {
              label: '贷款金额',
              field: 'fi__totalAmount'
            },
            {
              label: '期数',
              field: 'plan__sequenceNo'
            },
            {
              label: '还款日期',
              field: 'plan__repayDate'
            },
            {
              label: '还款金额',
              field: 'plan__repayAmount'
            },
            {
              label: '本金',
              field: 'plan__principalAmount'
            },
            {
              label: '利息',
              field: 'plan__interestAmount'
            },
            {
              label: '服务费',
              field: 'plan__lendingFeeAmount'
            },
            {
              label: '操作',
              opts:[
                {
                  label: '选择',
                  class: 'el-icon-edit',
                  clickHandler: (index, row)=> {
                    this.updateOutstanding(row.plan__entryId)
                  }
                },
              ]
            }
          ],
          tableData: {
            count: 0,
            data: []
          },
          dealerTypeOptions:[],
          page: 1,
          pageSize: 20,
          actions: [
          ],
          filters: {
            labelWidth: '150px',
            form: {
              dt__deviceType:'',
            },
            columns: [
              {
                label: '客户姓名',
                component: 'el-input',
                field: 'c__customerName'
              },
              {
                label: '手机号',
                component: 'el-input',
                field: 'c__customerContactNo'
              },
              {
                label: '还款日期',
                component: 'date-range-picker',
                field: 'plan__repayDate',
                op: ['gteq', 'lteq'],
                dateFormat: ['yyyy-MM-dd 00:00:00','yyyy-MM-dd 23:59:59'],
                span: 14
              },

            ],
            onSubmit:()=>{
              this.page = 1
              this.getData()
            }
          }
        }
      },
      mounted() {
        this.getData()
      },
      computed: {
        filterParams() {
          return {
            pageSize: this.pageSize,
            pageOffset: (this.page - 1) * this.pageSize,
          }
        }
      },
      watch: {
        filterParams: function (newVal) {
          this.getData()
        }
      },
      methods: {
        getData: function () {
          xhr.getOutstandingList(
            Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
            res=> {
              try {
                this.tableData = res.data
              }catch(e){

              }
            })

        },
        updateOutstanding:function (entryId) {
          xhr.updateOutstanding(
            {
              entryId:entryId,
              detailId:this.detailId,
              resolve__checked:true
            },
            res=> {
              try{
                if(res.data.status == 'success') {
                  this.$router.push({
                    name: 'TransferRepaymentList'
                  })
                }else{

                  this.$message.error(res.data.msgs[0].text)
                }
              }catch (e) {

                this.$message.error(error.msgs[0].text)

              }
            }
          )
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/OutstandingList.vue